
/* styles */
require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-b6a7e3b6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector?type=styles&index=0!./map.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./mapImpl.js"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b6a7e3b6\"}!../../../vue-loader/lib/selector?type=template&index=0!./map.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/dist/components/map.vue
// module id = 814
// module chunks = 2